const restaurant = {
  restaurant: "Restoran", // translated 
  restaurants: "Mga restawran", // translated 
  category: "Kategorya", // translated 
  score: "Iskor", // translated 
  priceQuartile: "Kwartilyo ng presyo", // translated 
  scoreLowestFirst: "Iskor (pinakamababa muna)", // translated 
  scoreHighestFirst: "Iskor (pinakamataas muna)", // translated 
  priceLowestFirst: "Presyo (pinakamababa muna)", // translated 
  priceHighestFirst: "Presyo (pinakamataas muna)", // translated 
  allPrices: "Lahat ng presyo", // translated 
  reserve: "Reserba", // translated 
  dining: "Kainan", // translated 
};


export default restaurant;
